import axios from 'axios';

class Network {

  constructor() {
    this.currentUser = null;
  }

  async refreshSession() {
    return axios.post("/api/session/refresh");
  }

  async getSession() {
    return axios.get("/api/session");
  }

  delete(endpoint, data) {
    return new Promise((resolve, reject) => {
      return axios.delete(endpoint, data).then(response => {
        resolve(response);
      }).catch(e => {
        resolve(null);
      })
    })
  }

  post(endpoint, data) {
    return new Promise((resolve, reject) => {
      return axios.post(endpoint, data).then(response => {
        resolve(response);
      }).catch(e => {
        resolve(null);
      })
    })
  }

  get(endpoint) {
    return new Promise((resolve, reject) => {
      return axios.get(endpoint).then(response => {
        resolve(response);
      }).catch(e => {
        resolve(null);
      })
    })
  }
}

const network = new Network();

export default network;
